import React, { Fragment, useContext, useRef } from 'react';
import { ProjectAdminSubContainerStyled } from '../../styled';
import {
  Box,
  Text,
  Combobox,
  TextFieldSize,
  TextFieldAppearance,
  useMediaQuery,
  belowBreakpoint,
  Theme,
} from '@bechtel/gds';
import { RoleList } from './list';
import { ThemeContext } from 'styled-components';
import { noop } from 'lodash';
import { t, Trans } from '@lingui/macro';

export const ManageRoles = () => {
  const { breakpoints } = useContext<Theme>(ThemeContext);
  const isDesktop = useMediaQuery(belowBreakpoint(breakpoints.desktop));
  const containerEndRef = useRef<HTMLDivElement>(null);
  const scrollToBottom = () => {
    containerEndRef?.current?.scrollIntoView({ behavior: 'smooth' });
  };
  return (
    <Fragment>
      <ProjectAdminSubContainerStyled>
        <Box flexDirection={{ sm: 'column' }} flexGrow={{ sm: '1' }}>
          <Box
            alignItems={{ sm: 'center' }}
            justifyContent={{ sm: 'space-between' }}
            pt={{ sm: '700' }}
            pb={{ sm: '600' }}
            px={{ sm: '700' }}
            css={`
              background-color: ${({ theme }) => theme.colors.grey[100]};
              height: fit-content;
            `}
          >
            <Box pr={{ sm: '900' }}>
              <Text family="graphik" size="300" color="grey.1000" style={{ lineHeight: 1.5 }}>
                <Trans>
                  Customize the roles that are available to your project. Duplicating a role will copy over all default
                  permissions and notifications.
                </Trans>
              </Text>
            </Box>
            <Box style={isDesktop ? { minWidth: '200px' } : { minWidth: '352px' }}>
              <Combobox
                disabled={true}
                placeholder={t`Browse popular roles`}
                size={TextFieldSize.LARGE}
                items={[]}
                appearance={TextFieldAppearance.NORMAL}
                itemString={null}
                itemComponent={null}
                selectedComponent={null}
                selectedItem={null}
                onSelect={noop}
                handleChange={noop}
                restorePreviousOnSkip
                loading={false}
                messageOnNoResults={''}
              ></Combobox>
            </Box>
          </Box>
          <RoleList scrollToBottom={scrollToBottom} />
          <div style={{ width: 0, height: 0 }} ref={containerEndRef}></div>
        </Box>
      </ProjectAdminSubContainerStyled>
    </Fragment>
  );
};
